// extracted by mini-css-extract-plugin
module.exports =  {"TableAction":"TableAction__2jiiL","leftContent":"leftContent__t7UjJ"};